import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { HoverOverlay } from "../index";
import { Button } from "react-bootstrap";
function FilterToggle(props) {
    const { negate, onNegate, exists, onExists, disabled } = props;
    const existsButton = (_jsx(Button, { disabled: disabled, active: exists, className: "tol-filter-button exists", onClick: () => onExists(exists), children: _jsx("div", { className: "icon", children: "\u2203" }) }));
    const negateButton = (_jsx(Button, { disabled: disabled, active: negate, className: "tol-filter-button negate", onClick: () => onNegate(negate), children: _jsx("div", { className: "icon", children: "\u00AC" }) }));
    return (_jsxs("div", { className: "tol-filter-button-group", children: [!disabled ? (_jsx(HoverOverlay, { contents: "Filter by values that exist. This will exclude empty/null values.", followCursor: true, children: existsButton })) : (existsButton), !disabled ? (_jsx(HoverOverlay, { contents: "Negate this filter.", followCursor: true, children: negateButton })) : (negateButton)] }));
}
export default FilterToggle;
